﻿import { createApp } from 'vue'
import FindAnOfficeComponent from './findAnOffice.vue'
import VueCookies from 'vue-cookies'

var array = document.querySelectorAll('.find-an-office');
array.forEach(block => {
    let app = createApp().use(VueCookies);
    app.component('FindAnOfficeComponent', FindAnOfficeComponent)
    app.mount(block);
});